import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import sortbydot from '../../assets/image/sort_by_group.svg';
import Button from '../../component/ui/Button';
import Table from '../../component/table/Table';
import Pagination from '../../component/pagination';
import { toast } from 'react-toastify';
import { ExportTable } from '../../store/action/export/Export';
import DeleteCrediteNoteModel from './components/DeleteCrediteNoteModel';
import {
	delete_credit_note,
	fetchCreditNoteList,
	generatePurchaseCreditNotePdf,
	getCreditNotes,
} from '../../services/credit_note';
import { getDate } from '../../utils/dateUtils';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';
import advanceFilterOptions from '../../component/Filter/advanceFilterOptions';
import AdvanceFilter from '../../component/Filter/AdvanceFilter';
import clearAllFilter from '../../assets/image/clearAllFilter.svg';
import advanceFilterIcon from '../../assets/image/advanceFilter_white.svg';
import AdvanceFilterSelectInput from '../../component/Filter/AdvanceFilterSelectInput';
import {
	clearAdvanceFilter,
	removeSelectedInput,
	setAdvanceFilter,
	setAdvanceFilterPage,
	setAdvanceFilterTotalPage,
	setSelectedInput,
	setSelectedInputData,
	setSelectedInputValue,
} from '../../store/action/advanceFilter';
import { useDispatch, useSelector } from 'react-redux';
import { formatFilterName, getFiltersParams } from '../../helper';
import { CREDIT_NOTE_TYPE } from '../../utils/constant';
import PageLoader from '../../component/PageLoader';
import { hasPermission } from '../../utils/controller';
import DataNotFound from '../components/dataNotFound';
import { Plus } from 'lucide-react';

const sortIconMap = {
	asc: <IoIosArrowRoundUp />,
	desc: <IoIosArrowRoundDown />,
};

const CreditNote = () => {
	const suburl = localStorage.getItem('suburl');
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const {
		page: advanceFilterPage,
		totalPages: advanceFilterTotalPages,
		pageSize: advanceFilterPageSize,
		orderBy: advanceFilterOrderby,
		sortBy: advanceFilterSortBy,
		selectedInputs,
		isAdvanceFilterApplied,
	} = useSelector((state) => state.advanceFilter);
	const [searchParams, setSearchParams] = useSearchParams();
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const [loader, setLoader] = useState(false);
	const [bulkAction, setBulkAction] = useState([]);
	const [headerDropDown, setHeaderDropDown] = useState('All Credit Notes');
	const [sortDirection, setSortDirection] = useState({ credit_note_id: 'asc' });
	const [creditNote, setCreditNote] = useState({
		data: [],
		totalPages: 0,
		currentPage: 1,
	});
	const [selectedVendorsListForDelete, setSelectedVendorsListForDelete] = useState([]);
	const [deselectRows, setDeselectRows] = useState(null);
	const [isDeleteBulkConfirmationModalOpen, setIsDeleteBulkConfirmationModalOpen] = useState(false);
	const [creditNoteParams, setCreditNoteParams] = useState({
		page: Number(searchParams.get("page")) || 1,
		pageSize: Number(searchParams.get("pageSize")) || 20,
		orderBy: searchParams.get("orderBy") || "created_at",
		sortBy: searchParams.get("sortBy") || "desc",
		filters: {},
	});
	const [isAdvanceFilterOpen, setIsAdvanceFilterOpen] = useState(false);
	const [loading, setLoading] = useState({
		pdf: {
			button: 'pdf',
			isLoading: false,
		},
		download: {
			button: 'download',
			isLoading: false,
		},
	});

	const CreditNoteColoum = [
		{
			field: '',
			headerClass: 'HeaderBg',
			checkboxSelection: true,
			headerCheckboxSelection: true,
			minWidth: 50,
			maxWidth: 50,
			lockPosition: true,
		},

		{
			field: 'DATE',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 93,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => (
				<div
					className="header-clickable"
					onClick={() => sortDataList({ orderBy: 'date', sortBy: 'asc' })}
				>
					<div className="header-inner-55">
						<p className="table-header__label_invoices mb-0">
							DATE
							<span className="sort-icon">{sortIconMap[sortDirection?.date]}</span>
						</p>
					</div>
				</div>
			),
		},

		{
			field: 'CREDIT NOTE#',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 110,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => (
				<div
					className="header-clickable"
					onClick={() =>
						sortDataList({
							orderBy: 'credit_note_number',
							sortBy: 'asc',
						})
					}
				>
					<div className="header-inner-55">
						<p className="table-header__label_invoices mb-0">
							CREDIT NOTE#
							<span className="sort-icon">{sortIconMap[sortDirection?.credit_note_number]}</span>
						</p>
					</div>
				</div>
			),
			cellRenderer: (params) => {
				const PN = JSON.parse(params.data['CN']);
				return (
					<p className="mb-0">
						{PN?.cn}
						{PN?.is_draft === 0 && (
							<span className="badge bg-secondary rounded-pill ms-2 px-2 py-1 fs-11">Draft</span>
						)}
					</p>
				);
			},
		},

		{
			field: 'VENDOR NAME',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 120,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => (
				<div
					className="header-clickable"
					onClick={() => sortDataList({ orderBy: 'vendor_name', sortBy: 'asc' })}
				>
					<div className="header-inner-55">
						<p className="table-header__label_invoices mb-0">
							VENDOR NAME
							<span className="sort-icon">{sortIconMap[sortDirection?.vendor_name]}</span>
						</p>
					</div>
				</div>
			),
		},

		{
			field: 'STATUS',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 75,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => (
				<div
					className="header-clickable"
					onClick={() => sortDataList({ orderBy: 'status', sortBy: 'asc' })}
				>
					<div className="header-inner-55">
						<p className="table-header__label_invoices mb-0">
							STATUS
							<span className="sort-icon">{sortIconMap[sortDirection?.status]}</span>
						</p>
					</div>
				</div>
			),
			cellRenderer: (params) => <p className="mb-0">{params.data?.status}</p>,
		},

		{
			field: 'TYPE',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 100,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => (
				<div className="header-clickable">
					<div className="header-inner-55">
						<p className="table-header__label_invoices mb-0">TYPE</p>
					</div>
				</div>
			),
		},

		{
			field: 'AMOUNT',
			headerClass: 'HeaderBg right-align',
			suppressSizeToFit: true,
			minWidth: 90,
			flex: 1,
			cellClass: 'right-align',
			headerComponent: () => (
				<div
					className="header-clickable header-right"
					onClick={() =>
						sortDataList({
							orderBy: 'credit_note_amount',
							sortBy: 'asc',
						})
					}
				>
					<div className="header-inner-55">
						<p className="d-flex align-items-center justify-content-end text-dark  table-header__label_invoices mb-0">
							AMOUNT
							<span className="sort-icon">{sortIconMap[sortDirection?.credit_note_amount]}</span>
						</p>
					</div>
				</div>
			),
		},
	];

	const navigateRouter = (path) => {
		navigate(path);
	};
	const onRowClick = (id) => {
		if (id && hasPermission('purchases.credit_notes.view', user?.role?.role_permissions)) {
			navigate(`/user/${suburl}/credit-note-details/${id}`);
		}
	};
	const handleDeselectAll = (deselectAllRowsFn) => {
		setDeselectRows(() => deselectAllRowsFn);
	};

	const FilterDatalist = (param, value, dropDownData) => {
		if (dropDownData === 'All Credit Notes') {
			dispatch(clearAdvanceFilter());
			setHeaderDropDown('All Credit Notes');
			return;
		}
		if (param.filterBy === 'status') {
			setHeaderDropDown(dropDownData);
		}

		const updatedSelectedInput = selectedInputs.map((input) => {
			if (input.key === 'status') {
				return {
					...input,
					value: dropDownData,
				};
			}

			if (input.key === 'credit_note_type') {
				return {
					...input,
					value: value,
				};
			}

			return input;
		});

		let selectInputData = [];
		if (param.filterBy === 'status') {
			selectInputData = [
				{ key: 'draft', value: 'Draft' },
				{ key: 'active', value: 'Active' },
				{ key: 'close', value: 'Close' },
			];
			dispatch(setSelectedInput({ key: 'status', label: 'Status' }));
			dispatch(setSelectedInputValue({ key: 'status', value: dropDownData }));
		}

		if (param.filterBy === 'credit_note_type') {
			selectInputData = [
				{
					key: 'damaged_return_goods',
					value: 'Damaged/Return Goods',
				},
				{
					key: 'excess_payment',
					value: 'Excess Payment',
				},
				{
					key: 'advance_payment',
					value: 'Advance Payment',
				},
			];
			dispatch(setSelectedInput({ key: 'credit_note_type', label: 'Credit Note Type' }));
			dispatch(setSelectedInputValue({ key: 'credit_note_type', value: dropDownData }));
		}

		dispatch(setAdvanceFilter({ isAdvanceFilterApplied: true }));
		dispatch(setSelectedInputData({ key: param.filterBy, data: selectInputData }));

		const params = getFiltersParams(updatedSelectedInput);
		handleApplyFilters(params);
	};

	const sortDataList = (param) => {
		const newDirection = sortDirection[param.orderBy] === 'desc' ? 'asc' : 'desc';
		setSortDirection({ [param.orderBy]: newDirection });
		if (isAdvanceFilterApplied) {
			dispatch(setAdvanceFilter({ orderBy: param.orderBy, sortBy: newDirection }));
			const params = getFiltersParams(selectedInputs);
			handleApplyFilters(params);
		} else {
			setCreditNoteParams((prev) => ({
				...prev,
				orderBy: param.orderBy,
				sortBy: newDirection,
				filterValue: null,
			}));
		}
	};

	const exportData = (param) => {
		ExportTable(param);
	};

	async function handleBulkDelete() {
		try {
			await delete_credit_note(bulkAction);
			toast.success('Credit Note Deleted Successfully.');
			setIsDeleteBulkConfirmationModalOpen(false);
			setBulkAction([]);
			getCreditNoteList();
			deselectRows && deselectRows();
		} catch (error) {
			toast.error(error?.message || 'Something went wrong');
		}
	}

	function handleOpenBulkDeleteCrediteNoteModal() {
		const selectedVendorsList = creditNote?.data?.reduce((acc, item) => {
			if (bulkAction.includes(item.id)) {
				acc.push(JSON.parse(item.CN)?.cn);
				return acc;
			}
			return acc;
		}, []);
		setSelectedVendorsListForDelete(selectedVendorsList);
		setIsDeleteBulkConfirmationModalOpen(true);
	}

	async function handlePRPrintAndDownloadPdf(type = 'print') {
		try {
			setLoading((prev) => {
				const obj = {};
				obj.pdf = {
					button: type,
					isLoading: true,
				};

				return {
					...prev,
					...obj,
				};
			});
			const pdf_details = await generatePurchaseCreditNotePdf(bulkAction.join(','), true);
			const url = pdf_details.signed_url;

			if (type === 'print') {
				window.open(url, '_blank');
			}

			if (type === 'download') {
				const fileName = `merged_purchase_credit_notes_${Date.now()}.pdf`;
				const response = await fetch(url);
				const blob = await response.blob();
				const blobUrl = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = blobUrl;
				link.download = fileName;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				window.URL.revokeObjectURL(blobUrl);
			}
		} catch (err) {
		} finally {
			setLoading((prev) => ({
				...prev,
				pdf: {
					...prev.pdf,
					isLoading: false,
				},
				download: {
					...prev.download,
					isLoading: false,
				},
			}));
		}
	}

	//New Filter Start
	async function handleOnFocusSelectedFilterInput(key) {
		let selectInputData = [];
		if (key === 'status') {
			selectInputData = [
				{ key: 'draft', value: 'Draft' },
				{ key: 'active', value: 'Active' },
				{ key: 'close', value: 'Close' },
			];
		} else if (key === 'credit_note_type') {
			selectInputData = [
				{
					key: 'damaged_return_goods',
					value: 'Damaged/Return Goods',
				},
				{
					key: 'excess_payment',
					value: 'Excess Payment',
				},
				{
					key: 'advance_payment',
					value: 'Advance Payment',
				},
			];
		} else {
			const { data } = await fetchCreditNoteList({
				pageSize: 1000,
				filterBy: key,
				filterValue: '',
			});
			selectInputData = data?.reduce((acc, cn) => {
				if (key === 'vendor_name') {
					acc.push({
						key: cn.vendor?.vendor_name,
						value: cn.vendor?.vendor_name,
					});
					return acc;
				} else if (key === 'credit_note_number') {
					acc.push({
						key: cn.credit_note_number,
						value: cn.credit_note_number,
					});
					return acc;
				} else {
					acc.push({
						key: cn.credit_note_amount,
						value: cn.credit_note_amount,
					});
					return acc;
				}
			}, []);
		}

		dispatch(setSelectedInputData({ key, data: selectInputData }));
	}

	async function searchSelectedInputItems(key, value) {
		try {
			let optionsList;
			if (key === 'status') {
				optionsList = [
					{ key: 'draft', value: 'Draft' },
					{ key: 'active', value: 'Active' },
					{ key: 'close', value: 'Close' },
				];
			} else if (key === 'credit_note_type') {
				optionsList = [
					{
						key: 'damaged_return_goods',
						value: 'Damaged/Return Goods',
					},
					{
						key: 'excess_payment',
						value: 'Excess Payment',
					},
					{
						key: 'advance_payment',
						value: 'Advance Payment',
					},
				];
			} else {
				const params = {
					filterBy: key,
					filterValue: value,
					pageSize: 1000,
				};
				const { data } = await fetchCreditNoteList(params);

				optionsList = data?.map((vendor) => {
					return {
						key: vendor[key],
						value: vendor[key],
					};
				});
			}
			dispatch(setSelectedInputData({ key, data: optionsList }));
		} catch (error) {
			toast.error(error?.message || 'Something went wrong!');
		}
	}

	async function handleApplyFilters(params) {
		try {
			if (Object.keys(params).length === 0) return;

			if (params?.status) {
				setHeaderDropDown(params?.status === 1 ? 'Active' : params?.status);
			}

			const updatedParams = { ...params };

			if (updatedParams.credit_note_type === 'Damaged/Return Goods') {
				updatedParams.credit_note_type = 1;
			}

			if (updatedParams.credit_note_type === 'Excess Payment') {
				updatedParams.credit_note_type = 2;
			}

			if (updatedParams.credit_note_type === 'Advance Payment') {
				updatedParams.credit_note_type = 3;
			}

			if (updatedParams.status === 'Draft') {
				updatedParams.status = 0;
			}

			if (updatedParams.status === 'Active') {
				updatedParams.status = 1;
			}

			if (updatedParams.status === 'Close') {
				updatedParams.status = 2;
			}
			const { credit_notes, totalPages } = await getCreditNotes({
				orderBy: advanceFilterOrderby,
				sortBy: advanceFilterSortBy,
				page: advanceFilterPage,
				pageSize: advanceFilterPageSize,
				filters: updatedParams,
			});
			const filterData = credit_notes.map((ele) => {
				return {
					id: ele.credit_note_id,
					DATE: getDate(ele?.date),
					CN: JSON.stringify({ cn: ele?.credit_note_number, is_draft: ele?.status }),
					'VENDOR NAME': ele?.vendor_name,
					TYPE: CREDIT_NOTE_TYPE[Number(ele?.credit_note_type)],
					status: ele?.status === 0 ? 'N/A' : ele?.status === 1 ? 'Active' : 'Closed',
					AMOUNT:
						Number(ele?.credit_note_type) === 3
							? Number(ele?.payment_amount).toFixed(2)
							: Number(ele?.credit_note_amount || 0).toFixed(2),
				};
			});
			dispatch(setAdvanceFilterTotalPage({ totalPages }));
			setCreditNote((prev) => ({
				...prev,
				data: filterData,
				totalPages: totalPages,
			}));

			setIsAdvanceFilterOpen(false);
		} catch (error) {
			toast.error(error?.message || 'Something went wrong! Try again.');
		}
	}

	async function getCreditNoteList() {
		try {
			setLoader(true);
			const { credit_notes, totalPages } = await getCreditNotes(creditNoteParams);
			const creditNoteData = credit_notes?.map((ele) => {
				return {
					id: ele.credit_note_id,
					DATE: getDate(ele?.date),
					CN: JSON.stringify({ cn: ele?.credit_note_number, is_draft: ele?.status }),
					'VENDOR NAME': ele?.vendor_name,
					TYPE: CREDIT_NOTE_TYPE[Number(ele?.credit_note_type)],
					status: ele?.status === 0 ? 'N/A' : ele?.status === 1 ? 'Active' : 'Closed',
					AMOUNT: Number(ele?.credit_note_amount || 0).toFixed(2),
				};
			});
			setCreditNote((prev) => ({
				...prev,
				data: creditNoteData,
				totalPages,
			}));
		} catch (error) {
			toast.error('somethings went wrong!');
		} finally {
			setLoader(false);
		}
	}

	const setHeaderDropdownStatus = (filters) => {
		const statusMap = {
			'0': 'Draft',
			'1': 'Active',
			'2': 'Close',
		};
		if (filters.status !== undefined) {
			setHeaderDropDown(statusMap[filters.status]);
		}
	}

	const setFilterFromUrl = () => {
		const filters = {};
		searchParams.forEach((value, key) => {
			if (
				key !== "page" &&
				key !== "pageSize" &&
				key !== "orderBy" &&
				key !== "sortBy"
			) {
				filters[key] = value;
			}
		});
		setSortDirection({
			[searchParams.get("orderBy")]: searchParams.get("sortBy") || "",
		});
		setHeaderDropdownStatus(filters);
		Object.entries(filters).forEach(([key, value]) => {
			const statusValueMap = {
				'0': 'Draft',
				'1': 'Active',
				'2': 'Close',
			};
			const fieldValue =
				key === 'status'
					? statusValueMap[value]
					: value;
			dispatch(
				setSelectedInput({
					key: key,
					label: formatFilterName(key),
				})
			);
			dispatch(
				setSelectedInputValue({
					key: key,
					value: fieldValue,
				})
			);
			handleOnFocusSelectedFilterInput(key);
		});
		if (Object.keys(filters).length > 0) {
			dispatch(setAdvanceFilter({
				isAdvanceFilterApplied: true,
				page: Number(searchParams.get("page")) || 1,
				pageSize: Number(searchParams.get("pageSize")) || 20,
				orderBy: searchParams.get("orderBy") || "created_at",
				sortBy: searchParams.get("sortBy") || "desc"
			}));
		}
	};

	useEffect(() => {
		setFilterFromUrl();
	}, []);

	function getParams(params) {
		const status = params.status === '1' ? 'Active' : params.status;
		if (!status) return params;
		setHeaderDropDown(status);
		const statusMap = {
			'Draft': 0,
			'Active': 1,
			'Close': 2,
		};
		return {
			...params,
			status: statusMap[status],
		};
	}

	const setUrlSearchParams = () => {
		const url = new URLSearchParams();
		// Normal params
		url.set("page", isAdvanceFilterApplied ? advanceFilterPage : creditNoteParams.page);
		url.set("pageSize", isAdvanceFilterApplied ? advanceFilterPageSize : creditNoteParams.pageSize);
		url.set(
			"orderBy",
			isAdvanceFilterApplied ? advanceFilterOrderby : creditNoteParams.orderBy
		);
		url.set(
			"sortBy",
			isAdvanceFilterApplied ? advanceFilterSortBy : creditNoteParams.sortBy
		);
		if (selectedInputs.length > 0) {
			const filters = getParams(getFiltersParams(selectedInputs));
			Object.entries(filters).forEach(([key, value]) => {
				if (value !== undefined && value !== null && value !== '') {
					url.set(key, value);
				}
			});
		} else {
			Object.entries(creditNoteParams.filters).forEach(([key, value]) => {
				url.set(key, value);
			});
		}

		setSearchParams(url);
	}

	useEffect(() => {
		setUrlSearchParams();
	}, [
		creditNoteParams,
		selectedInputs,
		advanceFilterPage,
		advanceFilterPageSize,
		advanceFilterOrderby,
		advanceFilterSortBy,
		isAdvanceFilterApplied
	]);



	useEffect(() => {
		const stockFilterKeys = [
			'vendor_name',
			'credit_note_number',
			'credit_note_type',
			'credit_note_amount',
			'status'
		];
		const hasStockFilter = stockFilterKeys.some((key) => searchParams.has(key));
		if (isAdvanceFilterApplied) {
			const params = getFiltersParams(selectedInputs);
			handleApplyFilters(params);
		} else {
			if (!hasStockFilter) {
				getCreditNoteList();
			}
		}
	}, [searchParams, isAdvanceFilterApplied]);

	return (
		<div>
			{bulkAction && bulkAction.length > 0 ? (
				<div
					className="product-pg-header"
					style={{ padding: '1.6rem 1rem' }}
				>
					<div className="dropdown text-end">
						<p className="d-block link-dark text-decoration-none">Bulk Actions</p>
					</div>
					<div className="add-product-button">
						<Button
							type="button"
							button="Print"
							disabled={
								!hasPermission(
									'purchases.credit_notes.download_print_pdf',
									user?.role?.role_permissions,
								)
							}
							className="mt-0 px-4 btn-gray"
							loader={loading.pdf.isLoading}
							onClick={() => handlePRPrintAndDownloadPdf('print')}
						/>

						<Button
							type="button"
							button="Delete"
							disabled={
								!hasPermission('purchases.credit_notes.delete', user?.role?.role_permissions)
							}
							className="mt-0 px-4 btn-gray relative"
							onClick={handleOpenBulkDeleteCrediteNoteModal}
						></Button>

						<Button
							type="button"
							button="Bulk Update"
							className="mt-0 px-4 btn-gray relative"
						></Button>

						<Button
							type="button"
							className="mt-0 btn-danger add-pro"
							button=""
							close
							onClick={() => {
								setBulkAction(false);
								setBulkAction([]);
								deselectRows && deselectRows();
							}}
						/>
					</div>
				</div>
			) : (
				<div className="product-pg-header add-product">
					<div
						className="dropdown text-end d-flex"
						style={{ gap: '12px', display: 'flex', alignItems: 'center' }}
					>
						<a
							className="d-block link-dark text-decoration-none dropdown-toggle"
							id="dropdownUser1"
							data-bs-toggle="dropdown"
							aria-expanded="false"
						>
							<p>{headerDropDown}</p>
						</a>
						<ul
							className="dropdown-menu font-14"
							aria-labelledby="dropdownUser1"
							style={{ minWidth: '240px' }}
						>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist(
											{
												orderBy: 'credit_note_id',
												sortBy: 'asc',
												filterBy: null,
												filterValue: null,
											},
											'',
											'All Credit Notes',
										)
									}
								>
									All Credit Notes
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist({ filterBy: 'status', filterValue: 0 }, 'draft', 'Draft')
									}
								>
									Draft
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist({ filterBy: 'status', filterValue: 1 }, 'active', 'Active')
									}
								>
									Active
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist({ filterBy: 'status', filterValue: 2 }, 'close', 'Close')
									}
								>
									Close
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist(
											{ filterBy: 'credit_note_type', filterValue: 1 },
											1,
											'Damaged/Return Goods',
										)
									}
								>
									Damaged/Return Goods
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist(
											{ filterBy: 'credit_note_type', filterValue: 2 },
											2,
											'Excess Payment',
										)
									}
								>
									Excess Payment
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist(
											{ filterBy: 'credit_note_type', filterValue: 3 },
											3,
											'Advance Payment',
										)
									}
								>
									Advance Payment
								</a>
							</li>
						</ul>
						<div>
							{isAdvanceFilterApplied ? (
								<div>
									<button
										onClick={() => {
											dispatch(clearAdvanceFilter());
											setHeaderDropDown('All Credit Notes');
										}}
										style={{
											background: 'transparent',
											color: '#FF0000',
											fontSize: '14px',
											cursor: 'pointer',
											fontWeight: '600',
											lineHeight: '24px',
										}}
									>
										<img
											src={clearAllFilter}
											alt=""
											style={{ width: '18px', height: '18px', marginRight: '8px' }}
										/>
										Clear All Filters
									</button>
								</div>
							) : (
								<Button
									type="button"
									button="Advanced Filters"
									className="mt-0 px-4 btn-primary"
									onClick={() => setIsAdvanceFilterOpen(true)}
									icon={advanceFilterIcon}
								/>
							)}
						</div>
					</div>

					<div className="add-product-button column-gap-0">
						<Button
							type="button"
							className="btn-primary mt-0 px-5"
							disabled={
								!hasPermission('purchases.credit_notes.create', user?.role?.role_permissions)
							}
							button="Create New Credit Note"
							add
							onClick={() => navigateRouter(`/user/${suburl}/credit-note-create`)}
						/>
						<div className="dropdown text-end ms-3">
							<a
								href="#"
								className="d-block link-dark text-decoration-none"
								id="dropdownUser1"
								data-bs-toggle="dropdown"
								aria-expanded="false"
							>
								<img src={sortbydot} alt='' />
							</a>
							{/* date , reason, created_at , description,status,reference_number, */}
							<ul
								className="dropdown-menu font-14"
								aria-labelledby="dropdownUser1"
								style={{ minWidth: '240px' }}
							>
								<li>
									<a className="dropdown-item sortBy">Sort By</a>
								</li>

								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => sortDataList({ orderBy: 'created_at', sortBy: 'asc' })}
									>
										Created Time
										<span>{sortIconMap[sortDirection?.created_at]}</span>
									</a>
								</li>
								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => sortDataList({ orderBy: 'updated_at', sortBy: 'asc' })}
									>
										Modified Time
										<span>{sortIconMap[sortDirection?.updated_at]}</span>
									</a>
								</li>
								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => sortDataList({ orderBy: 'date', sortBy: 'asc' })}
									>
										Date
										<span>{sortIconMap[sortDirection?.date]}</span>
									</a>
								</li>
								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => sortDataList({ orderBy: 'credit_note_date', sortBy: 'asc' })}
									>
										Credit Note Date
										<span>{sortIconMap[sortDirection?.credit_note_date]}</span>
									</a>
								</li>
								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => sortDataList({ orderBy: 'credit_note_number', sortBy: 'asc' })}
									>
										Credit Note#
										<span>{sortIconMap[sortDirection?.credit_note_number]}</span>
									</a>
								</li>
								<li>
									<a
										className="dropdown-item"
										onClick={() => sortDataList({ orderBy: 'vendor_name', sortBy: 'asc' })}
									>
										Vendor Name
										<span>{sortIconMap[sortDirection?.vendor_name]}</span>
									</a>
								</li>
								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => sortDataList({ orderBy: 'credit_note_amount', sortBy: 'asc' })}
									>
										Amount
										<span>{sortIconMap[sortDirection?.credit_note_amount]}</span>
									</a>
								</li>
								<li>
									<a
										className={`dropdown-item ${!hasPermission('purchases.credit_notes.export', user?.role?.role_permissions) ? 'disabled' : ''}`}
										onClick={() => exportData(`credit_note`)}
									>
										Export Credit Note
									</a>
								</li>

								<li>
									<a
										className="dropdown-item"
										onClick={() => {
											setHeaderDropDown('All Credit Notes');
											setCreditNoteParams({
												page: 1,
												pageSize: 20,
												orderBy: 'credit_note_id',
												sortBy: 'asc',
												filterBy: null,
												filterValue: null,
											});
										}}
									>
										Refresh
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			)}

			<div className="active-filter-wrapper">
				{isAdvanceFilterApplied && (
					<div className="active-filter-list">
						{selectedInputs.map((item) => (
							<AdvanceFilterSelectInput
								key={item.key}
								options={item?.data}
								placeholder={`Select ${item?.label}`}
								value={item?.value}
								disabled={false}
								onFocusCb={() => {
									if (item.value === '') {
										handleOnFocusSelectedFilterInput(item?.key);
									}
								}}
								onChange={(value) => {
									//	searchSelectedInputItems(item?.key, value)
								}}
								onSelect={(option) => {
									if (item?.key === 'status') {
										setHeaderDropDown(option?.value);
									}

									if (item?.key === 'credit_note_type') {
										setHeaderDropDown(option?.value);
									}

									const updatedSelectedInput = selectedInputs.map((input) => {
										if (input.key === item?.key) {
											return {
												...input,
												value: option?.value,
											};
										}
										return input;
									});
									const params = getFiltersParams(updatedSelectedInput);
									handleApplyFilters(params);
									dispatch(setSelectedInputValue({ key: item?.key, value: option.value }));
								}}
								removeInput={() => {
									dispatch(removeSelectedInput({ key: item?.key }));
									const params = getFiltersParams(
										selectedInputs.filter((input) => input.key !== item?.key),
									);
									if (item?.key === 'status') {
										setHeaderDropDown('All Credit Notes');
									}
									handleApplyFilters(params);
								}}
								className="selectInput"
							/>
						))}
						<div className="add-filter-btn-wrapper">
							<button
								type="button"
								className="add-filter-btn"
								onClick={() => setIsAdvanceFilterOpen(true)}
							>
								<span className="add-filter-btn__icon"><Plus width={15} /></span>
								Add Filter
							</button>
						</div>
					</div>
				)}
			</div>

			{isDeleteBulkConfirmationModalOpen && (
				<DeleteCrediteNoteModel
					isDeleteBulkConfirmationModalOpen={isDeleteBulkConfirmationModalOpen}
					setIsDeleteBulkConfirmationModalOpen={setIsDeleteBulkConfirmationModalOpen}
					selectedVendorsListForDelete={selectedVendorsListForDelete}
					handleBulkDelete={handleBulkDelete}
					purchaseOrderLength={bulkAction.length}
				/>
			)}

			{loader ? (
				<PageLoader />
			) : creditNote.data.length > 0 ? (
				<div className="productTable-body">
					<Table
						row={creditNote?.data}
						coloum={CreditNoteColoum}
						className="productTable"
						onRowClick={onRowClick}
						bulkAction={bulkAction}
						action={setBulkAction}
						style={isAdvanceFilterApplied ? { height: 'calc(100vh - 185px)' } : { height: 'calc(100vh - 148px)' }}
						onDeselectAll={handleDeselectAll}
					/>
				</div>
			) : (
				<DataNotFound
					title={'Manage returns with ease!'}
					subtitle={'Create and track credit notes to adjust invoices and '}
					content={'maintain accurate accounts.'}
					descriptionTitle={'Stay accurate!'}
					descriptionSubTitle={'Handle returns, adjustments, and refunds — all in one'}
					descriptionContent={'organized place.'}
					buttonText={'Create New Credit Note'}
					disabled={!hasPermission('purchases.credit_notes.create', user?.role?.role_permissions)}
					onClick={() => navigateRouter(`/user/${suburl}/credit-note-create`)}
				/>
			)}
			{creditNote.data.length > 0 && (
				<Pagination
					currentPage={isAdvanceFilterApplied ? advanceFilterPage : creditNoteParams.page}
					totalPages={isAdvanceFilterApplied ? advanceFilterTotalPages : creditNote?.totalPages}
					pageSize={isAdvanceFilterApplied ? advanceFilterPageSize : creditNoteParams.pageSize}
					setParam={(value) => {
						if (isAdvanceFilterApplied) {
							dispatch(setAdvanceFilterPage({ page: 1, pageSize: value }));
						} else {
							setCreditNoteParams((prev) => ({
								...prev,
								pageSize: value,
								page: 1,
							}));
						}
					}}
					onChangePage={(page) => {
						if (isAdvanceFilterApplied) {
							dispatch(setAdvanceFilterPage({ page: page }));
						} else {
							setCreditNoteParams((prev) => ({
								...prev,
								page,
							}));
						}
					}}
				/>
			)}

			{/* Advance Filter  */}
			{isAdvanceFilterOpen && (
				<AdvanceFilter
					modalLabel="Note: You can create a bill for either Yet to Receive Items or Received Items."
					isOpen={isAdvanceFilterOpen}
					advanceFilterOptions={advanceFilterOptions?.credit_note}
					onFocusSelectedFilterInput={handleOnFocusSelectedFilterInput}
					handleOnChangeSelectedFilterInput={(key, value) => searchSelectedInputItems(key, value)}
					onClose={() => {
						setIsAdvanceFilterOpen(false);
					}}
					onApply={handleApplyFilters}
				/>
			)}
		</div>
	);
};

export default CreditNote;
